import React from "react";

const JuridentFeatures = () => {
  const features = [
    {
      title: "Quick Legal Assistance",
      description: "Get instant guidance on legal queries directly through the app, saving time and ensuring reliable advice whenever needed.",
    },
    {
      title: "Document Management",
      description: "Upload, organize, and manage your legal documents securely in one centralized location with easy access anytime.",
    },
    {
      title: "Case Tracking",
      description: "Monitor the status of your ongoing cases in real time and receive timely updates to stay informed at all times.",
    },
    {
      title: "Notifications",
      description: "Receive important alerts and reminders about deadlines, appointments, and legal events directly within the app.",
    },
    {
      title: "Secure Chat",
      description: "Communicate with legal experts safely and privately using the app's secure messaging feature.",
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="max-w-5xl mx-auto px-6 py-20 md:py-28 mt-12">
        <h1 className="text-2xl md:text-4xl font-bold text-center mb-4 text-gray-900">
          Jurident App Features
        </h1>
        <p className="text-base md:text-lg text-center text-gray-600 max-w-2xl mx-auto leading-relaxed">
          A comprehensive application developed to provide legal assistance and streamline document management for businesses and individuals.
        </p>
      </div>

      {/* Features Grid */}
      <div className="max-w-5xl mx-auto px-6 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-amber-50/30 rounded-lg p-6 hover:shadow-md transition-all duration-200 border border-amber-100/50"
            >
              <h2 className="text-lg font-semibold mb-3 text-gray-900">
                {feature.title}
              </h2>
              <p className="text-gray-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Section */}
      <div className="max-w-4xl mx-auto px-6 pb-20">
        <div className="bg-gradient-to-br from-white to-amber-50/30 rounded-lg p-8 md:p-10 border border-amber-100/50">
          <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-4 text-center">
            Built by Experts, Designed for You
          </h3>
          <p className="text-gray-600 text-base leading-relaxed text-center">
            The Jurident team combines experienced developers, designers, and legal consultants to ensure that the app not only meets user-friendly standards but also delivers high efficiency and effectiveness. Continuous improvement is at the core of Jurident, ensuring the app evolves to meet the changing needs of its users.
          </p>
        </div>
      </div>
    </div>
  );
};

export default JuridentFeatures;
